<template>
	<section class="itv-detail">
		<div class="itv-vacancies__container">
			<breadcrumbs
				v-if="breadcrumbs"
				class="itv-catalog__breadcrumbs"
				:content="breadcrumbs"
			/>
			<div class="itv-detail__container">
				<div class="itv-detail__wrap">
					<div class="itv-detail__wrapper">
						<div class="itv-vacancies__wrapper">
							<page-title :content="title" />
							<tags-list :content="tags" />
						</div>
						<div
							v-if="!isDesktop && !archive.isArchive"
							class="itv-vacancies__wrapper"
						>
							<div class="itv-detail__btn-wrapper">
								<div class="itv-detail__btn-wrap">
									<primary-button
										:content="anchor"
										@clickEvent="vacancyHandler"
									/>
								</div>
								<div class="itv-detail__btn-wrap">
									<social-button :content="socialButton" />
								</div>
							</div>
						</div>
						<div v-if="archive.isArchive" class="itv-vacancies__wrapper">
							<content-article :content="archive" />
						</div>
						<div class="itv-vacancies__wrapper">
							<content :content="content" />
						</div>
						<div class="itv-vacancies__wrapper">
							<content-article :content="contentArticle" />
						</div>
						<div
							v-if="!isDesktop && contentArticleSidebar.button.href"
							class="itv-vacancies__wrapper"
						>
							<content-article :content="contentArticleSidebar" />
						</div>
					</div>
				</div>
				<div v-if="isDesktop" class="itv-detail__wrap">
					<div v-if="!archive.isArchive" class="itv-detail__btn-wrapper">
						<div class="itv-detail__btn-wrap">
							<primary-button :content="anchor" @clickEvent="vacancyHandler" />
						</div>
						<div class="itv-detail__btn-wrap">
							<social-button :content="socialButton" />
						</div>
					</div>
					<content-article
						v-if="isDesktop && contentArticleSidebar.button.href"
						:content="contentArticleSidebar"
					/>
				</div>
			</div>
			<feedback-form v-if="!archive.isArchive" />
			<vacancies-short-list id="vacancies-list" :content="shortList" />
		</div>
	</section>
</template>

<script>
import PageTitle from './components/PageTitle'
import TagsList from './components/TagsList'
import PrimaryButton from './ui/PrimaryButton'
import SocialButton from './ui/SocialButton'
import Content from './components/Content'
import ContentArticle from './components/ContentArticle'
import VacanciesShortList from './components/VacanciesShortList'
import FeedbackForm from './components/FeedbackForm'
import Breadcrumbs from './components/Breadcrumbs'

export default {
	name: 'Detail',
	components: {
		PageTitle,
		TagsList,
		PrimaryButton,
		Content,
		ContentArticle,
		VacanciesShortList,
		FeedbackForm,
		SocialButton,
		Breadcrumbs,
	},
	data() {
		return {
			title: '',
			tags: [],
			breadcrumbs: null,
			anchor: {
				btnColorType: 'green',
				text: 'Откликнуться на вакансию',
				href: '#vacancies-form',
			},
			socialButton: [
				{
					text: 'Телеграм',
					href: 'https://t.me/share/url?url=https://xn--d1aqf.xn--p1ai/career/vacancy/343820/',
					icon: '<svg width="20" height="16" viewBox="0 0 20 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M1.3749 6.8879C6.74359 4.62993 10.3236 3.14134 12.1148 2.42212C17.2292 0.36862 18.2919 0.0119045 18.9846 0.00012559C19.1369 -0.00246506 19.4776 0.0339819 19.6982 0.206816C19.8845 0.352754 19.9358 0.549895 19.9603 0.68826C19.9848 0.826626 20.0154 1.14183 19.9911 1.38811C19.714 4.1992 18.5147 11.021 17.9046 14.1694C17.6465 15.5017 17.1382 15.9484 16.6461 15.9921C15.5766 16.0871 14.7645 15.3098 13.7287 14.6543C12.1078 13.6287 11.1921 12.9902 9.61879 11.9893C7.80053 10.8327 8.97923 10.1969 10.0154 9.15799C10.2866 8.88609 14.9987 4.74867 15.0899 4.37335C15.1013 4.32641 15.1119 4.15143 15.0042 4.05904C14.8965 3.96664 14.7376 3.99824 14.6229 4.02337C14.4604 4.05898 11.871 5.71112 6.85486 8.97978C6.11988 9.46697 5.45416 9.70435 4.8577 9.69191C4.20015 9.6782 2.93528 9.33301 1.99498 9.03795C0.84166 8.67605 -0.074973 8.48471 0.00484519 7.87009C0.0464194 7.54996 0.503103 7.22256 1.3749 6.8879Z" fill="#737373"/></svg>',
				},
				{
					text: 'ВКонтакте',
					href: 'https://vk.com/share.php?url=https://xn--d1aqf.xn--p1ai/career/vacancy/343820/',
					icon: '<svg width="25" height="16" viewBox="0 0 25 16" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.8348 9.07143C21.0847 8.58929 21.9698 7.20714 22.6362 6.17857C24.6355 3.13571 25 2.49286 25 2.10714C25 1.81128 24.7669 1.57143 24.4793 1.57143H19.7934C19.5428 1.57237 19.3283 1.75699 19.2832 2.01071C19.0229 3.48929 15.649 7.73214 15.118 8C14.8993 8 14.5973 7.44286 14.5973 6.39286V1.87143C14.6551 1.51785 14.5642 1.15566 14.3474 0.875C13.9933 0.5 13.4623 0.5 11.9836 0.5C9.29702 0.5 8.33901 1.325 8.33901 2.10714C8.32745 2.24326 8.37132 2.37822 8.46016 2.47978C8.549 2.58135 8.67483 2.64041 8.8076 2.64286C8.8076 2.64286 9.38033 3.02857 9.38033 5.32143C9.40977 6.21663 9.36448 7.11277 9.24496 8C7.92249 7.75357 6.08978 4.35714 5.21508 1.91429C5.13338 1.69489 4.92227 1.55587 4.69442 1.57143H0.529177C0.373205 1.5688 0.224307 1.63827 0.123454 1.76072C0.0226016 1.88317 -0.0195782 2.04569 0.00852131 2.20357C0.591656 5.43929 7.20398 15.5 11.4629 15.5H13.5456C14.6494 15.5 14.7327 14.2679 14.7951 13.4536C14.8576 12.6393 14.9097 12.2857 15.1075 12.2857C15.7532 12.2857 17.0756 13.4643 17.9399 14.2357C18.8042 15.0071 19.3665 15.5 19.7934 15.5H22.3967C23.74 15.5 25 15.5 25 14.4286C25 14.0214 24.6564 13.55 22.6779 11.2143C22.0218 10.475 21.1367 9.45714 20.8348 9.07143Z" fill="#737373"/></svg>',
				},
			],
			content: '',
			contentArticle: {
				text: '',
			},
			contentArticleSidebar: {
				text: '<p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>',
				logo: '/static/v2/src/img/it-vacancies/bank_logo.png',
				button: {
					btnColorType: 'black',
					text: 'Подробнее о проекте',
					href: null,
				},
			},
			shortList: {
				title: 'Похожие вакансии',
				list: [],
			},
			archive: {
				isArchive: false,
				text: '<p>Вакансия находится в архиве. Вероятно, мы уже нашли кандидата и больше не принимаем отклики на эту вакансию</p>',
				button: {
					btnColorType: 'black',
					text: 'Похожие вакансии',
					href: '#vacancies-list',
				},
			},
		}
	},
	computed: {
		isDesktop() {
			return window.innerWidth >= 1200
		},
	},
	methods: {
		socialHandler() {},
		vacancyHandler() {},
	},
	created() {
		const main = document.querySelector('#vacancies-detail')
		if (main) {
			const data = JSON.parse(main.getAttribute('data'))
			const { sections, vacancy } = data
			this.shortList.list = vacancy.related.data
			this.title = vacancy.name
			this.contentArticle.text =
				sections.organizations.sections.domrf.props.description.value
			this.content = vacancy.detail_text

			if (sections.breadcrumbs) this.breadcrumbs = sections.breadcrumbs.props

			if (vacancy.props.biz === 'Y') {
				this.tags[0] = 'Бизнес'
			} else if (vacancy.props.intern === 'Y') {
				this.tags[0] = 'Стажировка'
			} else if (vacancy.props.it === 'Y') {
				this.tags[0] = 'IT и digital'
			}
			if (vacancy.props.city) {
				this.tags.push(vacancy.props.city)
			}
			if (vacancy.props.company) {
				this.tags.push(vacancy.props.company)
			}

			if (vacancy.active !== 'Y') {
				this.archive.isArchive = true
			}
		}
	},
}
</script>
